import * as React from 'react';

import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { Badge, IconButton, Popover, Tooltip } from '@mui/material';

import { useVenueGetUnreadNotificationCountQuery } from '../../hooks/reactQuery/notifications/useVenueGetUnreadNotificationCountQuery';
import { useVenueMarkNotificationsReceivedMutation } from '../../hooks/reactQuery/notifications/useVenueMarkNotificationsReceivedMutation';
import useVenueId from '../../hooks/useVenueId';
import NotificationsDropdown from './NotificationsDropdown';

const NotificationsBell: React.FC = () => {
  const venueID = useVenueId();
  const { count } = useVenueGetUnreadNotificationCountQuery(venueID);
  const markReceivedMutation = useVenueMarkNotificationsReceivedMutation({ venueID });

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);

      if (venueID && count > 0) {
        markReceivedMutation.mutate(venueID);
      }
    },
    [venueID, count, markReceivedMutation],
  );

  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <Tooltip title='Notifications'>
        <IconButton
          onClick={handleOpen}
          aria-label='notifications'
          aria-haspopup='true'
          sx={{
            color: 'rgba(0, 0, 0, 0.7)',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
          }}
        >
          <Badge
            badgeContent={count}
            max={99}
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#E91E63',
                color: 'white',
                fontSize: '0.65rem',
                minWidth: 16,
                height: 16,
                padding: '0 4px',
              },
            }}
          >
            <NotificationsNoneIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              borderRadius: 2,
              boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.12)',
              overflow: 'hidden',
            },
          },
        }}
      >
        <NotificationsDropdown onClose={handleClose} />
      </Popover>
    </>
  );
};

export default NotificationsBell;
